import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../hooks';

export const useCustomNavigate = () => {
  const navigate = useNavigate();
  const isMigrated = useAppSelector((state) => state?.isMigrated?.isMigrated);
  const queryParam = useAppSelector((state) => state?.isMigrated?.queryParam);
  const isOutageCheck = useAppSelector((state) => state.isOutageCheck?.isOutageCheck);
  const isOutageCheckQueryParam = useAppSelector((state) => state.isOutageCheck?.queryParam);
  const isSuspendNonPay = useAppSelector((state) => state?.isSuspendNonPay?.isSuspendNonPay)
  const isSuspendNonPayQueryParam = useAppSelector((state) => state?.isSuspendNonPay?.queryParam)
  const isVacationPause = useAppSelector((state) => state?.isVacationPause?.isVacationPause)
  const isVacationPauseQueryParam = useAppSelector((state) => state?.isVacationPause?.queryParam)

  const customNavigate = (path: string | number, options?: { replace?: boolean ; state?: any }) => {
    if (typeof path === 'number') {
        navigate(path);
      } else {
      let fullPath = path;
      localStorage.setItem("prevPath",window?.location.pathname);
      if (isMigrated && queryParam) {
        fullPath += fullPath.includes('?') ? `&${queryParam}` : `?${queryParam}`;
      }
      if (isOutageCheck && isOutageCheckQueryParam) {
      fullPath += fullPath.includes('?') ? `&${isOutageCheckQueryParam}` : `?${isOutageCheckQueryParam}`;
      }
      if (isSuspendNonPay && isSuspendNonPayQueryParam) {
      fullPath += fullPath.includes('?') ? `&${isSuspendNonPayQueryParam}` : `?${isSuspendNonPayQueryParam}`;
      }
      if (isVacationPause && isVacationPauseQueryParam) {
      fullPath += fullPath.includes('?') ? `&${isVacationPauseQueryParam}` : `?${isVacationPauseQueryParam}`;
      }
        navigate(fullPath, options);
      }
    };

  return { customNavigate };
};